/*
 * Developed for G.J. Gardner Homes by Softeq Development Corporation
 * http://www.softeq.com
 */

// tslint:disable:variable-name

import { createEnum, EnumSet } from '@gh/core-data';

export const ValidationStatus = createEnum('ValidationStatus', {
  SessionWasExpired: 'msg_session_was_expired',
  LoginDenied: 'msg_login_denied',
  LoginDeniedTemporarily: 'msg_login_denied_temporally',
  OfficeIsNotActivated: 'msg_login_office_not_activated',
  AcceptAgreement: 'msg_paypal_accept_agreement',
  PaymentInProcess: 'msg_paypal_payment_processing',
  CheckPayPalAccount: 'msg_paypal_overdue_payment',
});

export type ValidationStatus = EnumSet<typeof ValidationStatus>;
